var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('centered-container',{attrs:{"horizontal":"center"}},[_c('div',{staticClass:"loader-container"},[_c('app-loader',{staticClass:"loader"}),_c('span',[_vm._v("Loading...")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }